<template>
  <div
    class="ticket"
    :class="{ selected: checked }"
    @click="toggleTicket">
    <div class="ticket-toggle-field ripple">
      <input
        type="checkbox"
        :checked="checked">
      <span class="checkmark" />
    </div>
    <div class="ticket-details-field">
      <p class="ticket-field-title">{{ getTranslation('main.ticket_id') }}</p>
      <p class="ticket-field-value">{{ ticket.id }}</p>
    </div>
    <div class="ticket-details-field">
      <p class="ticket-field-title">{{ getTranslation('admin.table_header_datetime') }}</p>
      <p class="ticket-field-value">
        {{ ticket.ticketDateTimeUTC | time("DD.MM.YYYY HH:mm:ss") }}
      </p>
    </div>
    <div class="ticket-details-field">
      <p class="ticket-field-title">{{ getTranslation('admin.table_header_payin') }}</p>
      <p class="ticket-field-value">{{ ticket.payin.toFixed(2) }}</p>
    </div>
    <div class="ticket-details-field">
      <p class="ticket-field-title">{{ getTranslation('main.status') }}</p>
      <p class="ticket-field-value">{{ ticket.status.value }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ticket: {
      type: Object,
      required: true,
      default: () => {},
    },
    checkedTicket: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    checked() {
      return this.checkedTicket === this.ticket.id;
    },
  },
  methods: {
    toggleTicket() {
      this.$emit('toggleSelectedTicket', this.ticket.id);
    },
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
  },
};
</script>

<style lang="scss">
/* Ripple effect */
.ripple {
  background-position: center;
  transition: background 0.5s;

  &:hover {
    background: transparent radial-gradient(circle, transparent 1%, #0066ae 1%)
      center/15000%;
  }

  &:active {
    background-color: #0072a9;
    background-size: 100%;
    transition: background 0s;
  }
}

.ticket {
  display: flex;
  align-items: center;
  min-height: 3.5625rem;
  margin-bottom: 0.65rem;
  background-color: #242424;

  &.selected {
    background-color: #0066ae;
  }

  &-toggle-field {
    position: relative;
    flex-basis: 8%;
    align-self: stretch;
    text-align: center;
    min-width: 5rem;
  }

  &-details-field {
    flex-basis: 23%;
    display: flex;
    justify-content: space-between;
    align-self: stretch;
    flex-direction: column;
    padding: 0.4125rem 0.65rem;
    border-left: 1px solid #171717;
  }

  &-field-title,
  &-field-value {
    text-transform: uppercase;
  }

  &-field-title {
    font-size: 0.9em;
  }

  &-field-value {
    font-size: 1em;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ .checkmark:after {
      display: block;
    }
  }

  .checkmark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 2.1875em;
    width: 2.1875em;
    background-color: transparent;
    border-radius: 50%;
    border: .125rem solid #fff;

    &:after {
      content: "";
      position: absolute;
      display: none;
      left: .625em;
      top: .3125em;
      width: .625em;
      height: 1.0625em;
      border: solid #fff;
      border-width: 0 .1875em .1875em 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
}
</style>
